import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Col, Row} from "reactstrap";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {enumFormatter, getEnumOptions} from "../../utils/helper";
import {enums} from "../../Enums";
import {IWindow} from "../../index";
import {WardPicker} from "../form/fields/WardPicker";
import {LGAPicker} from "../form/fields/LGAPicker";
import {SenatorialDistrictPicker} from "../form/fields/SenatorialDistrictPicker";
import {FederalConstituencyPicker} from "../form/fields/FederalConstituencyPicker";
import {StateConstituencyPicker} from "../form/fields/StateConstituencyPicker";
import {PollingUnitPicker} from "../form/fields/PollingUnitPicker";

const IWindow: IWindow = (window as IWindow);

export class CandidateFormData {
    @observable subscription_id = IWindow.initialState.route.params.id || null;
    @observable election_id = null;
    @observable election_position_id = null;
    @observable name = '';
    @observable state_id = null;
    @observable level = '';
    @observable is_active = true;
    @observable local_government_areas = [];
    @observable wards = null;
    @observable states = [];
    @observable senatorial_districts = [];
    @observable federal_constituencies = [];
    @observable state_constituencies = [];
    @observable polling_units = null;
    @observable ward_id = null;
    @observable local_government_area_id = null;
}

export class CandidateForm extends CrudForm {
    modelName = 'Candidate';

    @observable subscription: any = null;

    loadMoreData(props: any, module: any) {
        api.subscription.getDetailAction(IWindow.initialState.route.params.id).then((data: any) => {
            this.subscription = data;
        });
    }

    getData = async () => {
        if (this.id) {
            this.isLoading = true;
            await api.candidate.getDetailAction(this.id).then((data: any) => {
                this.formStore.setData(data.data);
                this.entity = data.data;
            });
            this.isLoading = false;
        } else {
            this.isLoading = false;
        }
    };

    stateDropDown() {
        return this.formStore.getValue('level') === 'state' ?
            <Field
                key={this.formStore.getValue('state_id') + this.formStore.getValue('level')}
                label="Specific Area"
                name="states"
                placeholder="Select States"
                component={Select}
                loadOptions={() => {
                    return api.state.getListAction({
                        filters: {
                            election_id: this.subscription ? this.subscription.election_id : null,
                            election_position_id: this.formStore.getValue('election_position_id'),
                            level: this.formStore.getValue('level')
                        }
                    });
                }}
                store={this.formStore}
                multi={true}
                valueObject={true}
            /> : ''
    };

    lgaDropDown() {
        return this.formStore.getValue('level') === 'local_government_area' ?
            <Field
                label="Specific Area"
                name="local_government_areas"
                store={this.formStore}
                component={LGAPicker}
                filters={{
                    election_position_id: this.formStore.getValue('election_position_id'),
                    level: this.formStore.getValue('level'),
                }}
            /> : ''
    };

    wardsDropDown() {
        return this.formStore.getValue('level') == 'ward' ?
            <Field
                label="Specific Area"
                name="wards"
                store={this.formStore}
                component={WardPicker}
                filters={{
                    election_position_id: this.formStore.getValue('election_position_id'),
                    level: this.formStore.getValue('level'),
                }}
            /> : ''
    }

    senatorialDistrictDropDown() {
        return this.formStore.getValue('level') === 'senatorial_district' ?
            <Field
                label="Specific Area"
                name="senatorial_districts"
                store={this.formStore}
                component={SenatorialDistrictPicker}
                filters={{
                    election_position_id: this.formStore.getValue('election_position_id'),
                    level: this.formStore.getValue('level'),
                }}
            /> : ''

    }

    federalConstituencyDropDown() {
        return this.formStore.getValue('level') === 'federal_constituency' ?
            <Field
                label="Specific Area"
                name="federal_constituencies"
                store={this.formStore}
                component={FederalConstituencyPicker}
                filters={{
                    election_position_id: this.formStore.getValue('election_position_id'),
                    level: this.formStore.getValue('level'),
                }}
            /> : ''
    }

    stateConstituencyDropDown() {
        return this.formStore.getValue('level') === 'state_constituency' ?
            <Field
                label="Specific Area"
                name="state_constituencies"
                store={this.formStore}
                component={StateConstituencyPicker}
                filters={{
                    election_position_id: this.formStore.getValue('election_position_id'),
                    level: this.formStore.getValue('level'),
                }}
            /> : ''
    }

    pollingUnitDropDown() {
        return this.formStore.getValue('level') ==='polling_unit' ?
            <Field
                label="Polling Units"
                name="polling_units"
                store={this.formStore}
                component={PollingUnitPicker}
                filters={{
                    join_on_election:  this.subscription ? this.subscription.election_id : null
                }}
            /> : ''
    }

    renderFields() {
        return (
            <>
                {
                    this.subscription ?
                    <Field
                        label="Position"
                        name="election_position_id"
                        component={Select}
                        required={true}
                        loadOptions={() => {
                            return api.electionPosition.getListAction({
                                filters: {
                                    election_id: this.subscription.election_id
                                }
                            });
                        }}
                        store={this.formStore}
                        returnObject={true}
                        extraKey={'level'}
                        onChange={(item: any) => {
                            this.formStore.setValue('level', item.extraKey);
                            this.formStore.setValue('polling_units', []);
                            this.formStore.setValue('local_government_areas', []);
                            this.formStore.setValue('states', []);
                            this.formStore.setValue('wards', []);
                            this.formStore.setValue('senatorial_districts', []);
                            this.formStore.setValue('federal_constituencies', []);
                            this.formStore.setValue('state_constituencies', []);
                        }}
                    /> : ''
                }

                <Field
                    label="Candidate's Name"
                    name="name"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />
                {this.formStore.getValue('level') != 'polling_unit' ?
                    <Field
                        label="Level"
                        name="level"
                        placeholder="Select Level"
                        component={Select}
                        disabled={true}
                        options={getEnumOptions(enums.electionLevel)}
                        store={this.formStore}
                    /> : ''}

                {this.stateDropDown()}

                {this.lgaDropDown()}

                {this.wardsDropDown()}

                {this.senatorialDistrictDropDown()}

                {this.federalConstituencyDropDown()}

                {this.stateConstituencyDropDown()}

                {this.pollingUnitDropDown()}

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                />
            </>
        );
    }
}

export class CandidateFilterForm {
    @observable subscription_id = IWindow.initialState.route.params.id || null;
}

export class CandidateList extends CrudList {
    modelName = 'Candidate';
    @observable subscription: any = null;

    loadMoreData(props: any, module: any) {
        api.subscription.getDetailAction(IWindow.initialState.route.params.id).then((data: any) => {
            this.subscription = data;
        });
    }

    getSpecificAreas = (value: any, item: any) => {
        switch (item.level) {
            case 'federal':
                return 'federal';

            case 'state':
                return item.states.map((state: any) => state.name).join('/');

            case 'senatorial_district':
                return item.senatorial_districts.map((senatorialDistrict: any) => senatorialDistrict.name).join('/');

            case 'federal_constituency':
                return item.federal_constituencies.map((federalConstituency: any) => federalConstituency.name).join('/');

            case 'state_constituency':
                return item.state_constituencies.map((stateConstituency: any) => stateConstituency.name).join('/');

            case 'local_government_area':
                return item.local_government_areas.map((localGovernmentArea: any) => localGovernmentArea.name).join('/');

            case 'ward':
                return item.wards.map((ward: any) => ward.name).join('/');

            default:
                return '-';
        }
    };

    colums() {
        return [
            {
                name: "position.name",
                label: "Position",
            },
            {
                name: "name",
                label: "Party Candidate",
            },
            {
                name: "level",
                label: "Level",
                formatter: enumFormatter(enums.electionLevel),

            },
            {
                name: "specific_area",
                label: "Specific Area",
                formatter: this.getSpecificAreas,
            },
        ];
    }

    idColumn() {
        return '';
    }

    renderFilters() {
        if (!this.subscription) {
            return null;
        }

        return (
            <Row className="form-row">
                <Col md={12} className="grid-search">
                    <div className={'d-flex'}>
                        <label className={'p-3 bg-light rounded mr-2'}>{this.subscription.election.name}</label>
                        <label className={'p-3 bg-light rounded mr-2'}>{this.subscription.starts_at} to {this.subscription.ends_at}</label>
                        <label className={'p-3 bg-light rounded mr-2'}>{this.subscription.party.name}</label>
                        {this.renderSearch()} 
                    </div>
                </Col>
            </Row>
        );
    }
}

export class CandidatePage extends CrudPage {
    modelName = 'Candidate';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/CandidatePage.tsx